import { Theme, css } from '@emotion/react';

import { useTranslation } from 'next-i18next';

import { Radius, Spacing, Typography } from 'chatie-design-system';

import { IChatSituationInfo } from '@model';
import { linearGradient } from '@styles/css';
import { formatNumberWithUnit } from '@utils/chat';

const pickLabelCSS = (theme: Theme) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 18px;
  padding: ${Spacing.xxsmall}px 5px;
  color: ${theme.var.white};
  ${Typography.body11};
  ${linearGradient('right', theme.colors.main500, 'rgba(32, 162, 174, 0.6)')};
  line-height: 135%;
  border-radius: ${Radius.small}px;
`;

const PickLabel = ({ situation }: { situation: IChatSituationInfo }) => {
  const { t } = useTranslation();

  const tagTitle = formatNumberWithUnit(
    situation.stat?.created_chat_room_count
  );

  if (!tagTitle) {
    return <></>;
  }

  return <div css={pickLabelCSS}>{t(tagTitle)}</div>;
};

export default PickLabel;
